import { render } from "./digitalocean.vue?vue&type=template&id=09cde2a3"
import script from "./digitalocean.vue?vue&type=script&lang=js"
export * from "./digitalocean.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__